/**
 * Shared HTML allowlists. The renderer (sanitize-html, server-side) and the
 * editor's paste filter both derive from these constants so client and server
 * agree on exactly one policy.
 */

export const RICHTEXT_ALLOWED_TAGS = [
    "p",
    "br",
    "strong",
    "b",
    "em",
    "i",
    "u",
    "s",
    "a",
    "span",
    "ul",
    "ol",
    "li",
] as const;

export const RAWHTML_ALLOWED_TAGS = [
    ...RICHTEXT_ALLOWED_TAGS,
    "table",
    "thead",
    "tbody",
    "tfoot",
    "tr",
    "td",
    "th",
    "div",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "img",
    "hr",
    "blockquote",
    "center",
] as const;

export const ALLOWED_URL_SCHEMES = ["http", "https", "mailto", "tel"] as const;

/** True if a URL is safe for links/images in email content. Merge-tag-only
 * values like {{unsubscribe_url}} are allowed. */
export function isSafeUrl(value: string): boolean {
    const trimmed = value.trim();
    if (trimmed === "") return true;
    if (/^\{\{[a-zA-Z0-9_.|\s-]+\}\}$/.test(trimmed)) return true;
    if (trimmed.startsWith("#") || trimmed.startsWith("/")) return true;
    const m = /^([a-zA-Z][a-zA-Z0-9+.-]*):/.exec(trimmed);
    if (!m) return true; // schemeless relative URL
    return (ALLOWED_URL_SCHEMES as readonly string[]).includes(m[1]!.toLowerCase());
}
